module.exports = __webpack_public_path__ + "static/visualcontent-7498c1513e628fa62a6bb0614e383337.png";